// extracted by mini-css-extract-plugin
export default {"upload-more":"_2YjS9","uploadMore":"_2YjS9"};